import { Component } from '@angular/core';
import { LeaderboardType, PopulationQuery } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-predictor-leaderboard-page',
  templateUrl: './predictor-leaderboard-page.component.html',
  styleUrl: './predictor-leaderboard-page.component.scss',
})
export class PredictorLeaderboardPageComponent {
  populations = Populations;
  isKid: boolean;
  LeaderboardType: LeaderboardType;

  constructor(private populationQuery: PopulationQuery) { }

  ngOnInit(): void {
    this.isKid = this.populationQuery.userInPopulation([this.populations.JuniorBluebirds]);
    if (this.isKid) {
      this.LeaderboardType = LeaderboardType.PredictorEntries;
    } else {
      this.LeaderboardType = LeaderboardType.PredictorPoints;
    }
  }
}
